// extracted by mini-css-extract-plugin
export var buttonContent = "_49-0";
export var centered = "_49-1";
export var centeredFlex = "_49-2";
export var errorText = "_49-3";
export var icon = "_49-4";
export var iconButtonContent = "_49-5";
export var monospace = "_49-6";
export var padded = "_49-7";